import React, { useState } from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import { Calculate } from "@mui/icons-material";
import api from "../../api";
// Frontend'deki hesaplama fonksiyonlarını içeri aktarıyoruz
import { calculateAkkClass } from "../../utils/akkUtils";
import { calculateStorieIndex } from "../../utils/storieUtils";

export default function RecalculateAllButton({ onComplete }) {
  const [loading, setLoading] = useState(false);

  const handleRecalculate = async () => {
    if (
      !window.confirm(
        "⚠️ DİKKAT!\n\nSistemdeki TÜM profiller çekilecek, Frontend (Tarayıcı) üzerinde AKK/Storie indeksleri yeniden hesaplanacak ve sunucuya kaydedilecektir.\n\nOnaylıyor musunuz?",
      )
    ) {
      return;
    }

    setLoading(true);
    try {
      // 1. Tüm profilleri Backend'den ham haliyle getir
      const fetchRes = await api.get("/admin/all-profiles-raw");
      if (!fetchRes.data.success) throw new Error("Profiller çekilemedi");

      const profiles = fetchRes.data.data;
      const updatedProfiles = [];

      // 2. Frontend üzerinde hesaplama döngüsü
      for (const profile of profiles) {
        let fullData = {};
        try {
          fullData =
            typeof profile.full_data === "string"
              ? JSON.parse(profile.full_data)
              : profile.full_data || {};
        } catch (e) {
          continue; // Hatalı veriyi atla
        }

        // AKK ve Storie İndeksini Hesapla
        const akkResult = calculateAkkClass(fullData);
        const storieResult = calculateStorieIndex(fullData);

        const finalAkk = akkResult.finalClass + akkResult.subClassString;
        const finalStorie = storieResult.totalIndex || storieResult.finalIndex;

        // Hesaplanan sonuçları objeye yaz
        fullData.akk_class_result = finalAkk;
        fullData.storie_index_result = finalStorie;

        // Güncellenmek üzere diziye ekle
        updatedProfiles.push({
          id: profile.id,
          akk_sonuc: finalAkk,
          storie_index: finalStorie,
          full_data: fullData,
        });
      }

      // 3. Güncellenmiş koca listeyi Backend'e gönderip kaydet
      const updateRes = await api.put("/admin/update-bulk-profiles", {
        profiles: updatedProfiles,
      });

      if (updateRes.data.success) {
        alert(updateRes.data.message);
        if (onComplete) onComplete(); // Tabloyu yenile
      }
    } catch (error) {
      console.error(error);
      alert("❌ Yeniden hesaplama işlemi başarısız oldu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Formülleri cihazınızda (frontend) çalıştırıp hatalı AKK'leri düzeltir">
      <Button
        variant="contained"
        onClick={handleRecalculate}
        disabled={loading}
        startIcon={
          loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <Calculate />
          )
        }
        sx={{
          bgcolor: "#ff9800",
          color: "white",
          fontWeight: "bold",
          borderRadius: "10px",
          whiteSpace: "nowrap",
          "&:hover": {
            bgcolor: "#f57c00",
          },
        }}
      >
        {loading ? "Hesaplanıyor..." : "Tüm AKK'leri Düzelt"}
      </Button>
    </Tooltip>
  );
}
